export const ZeroMeTM = 'ZeroMe™';
export const CO2E = 'CO₂E';
export const KGCO2E = `kg ${CO2E}`;
export const MTCO2E = `MT ${CO2E}`;
export const MTofCO2E = `MT of ${CO2E}`;
